export enum EntitiesList {
    BILLING = 'billing',
    PERSONA = 'persona',
    ACCOUNT = 'account',
    SUBSCRIPTION = 'subscription',
    DETAILS = 'details',
    PLANS = 'plans',
    INVOICES = 'invoices',
    RECEIPT = 'receipt',
    CARD = 'card',
    LINK = 'link',
    EDIT = 'edit',
    DIBS_STATUS = 'dibs-status',
    VERIFY_LIMITS = 'verify-limits',
}

export enum RestrictionsEntitiesList {
    USERS = 'users',
    PERSONA = 'persona',
    RESTRICTIONS = 'restrictions',
    USERLIMITWARNING = 'user-limit-warning',
}
